import React, {PureComponent} from 'react';
import FreelanceAgent from "../../../../../shared/components/Dashboard/FreelanceAgent.jsx";
import api from "../../../../../api.js"
import nl2br from 'react-nl2br';

import DashboardLayout from "../../../Layout/DashboardLayout.jsx";

import Card from "../../../../../shared/components/Styled/Dasboard/Card.jsx";
import CardRow from "../../../../../shared/components/Styled/Dasboard/CardRow.jsx";
import CardCol from "../../../../../shared/components/Styled/Dasboard/CardCol.jsx";

import "./MyAgent.scss"

export default class MyAgent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      agent: {
        linkedin_url: undefined,
        fullname: undefined,
        email: undefined,
        tel: undefined,
        image: undefined,
        description: undefined,
      },
    }
    this.loadFreelanceAgent(this.props.freelance);
  }

  loadFreelanceAgent = async (freelance) => {
    await api.freelances.getMyAgent({
      freelance: freelance.id
    }).then((response) => {
      if(response && response.data && response.status === 200) {
        this.setState({agent: response.data})
      }
    });
  }

  render() {
    const {agent} = this.state
    const calendlyUrl = agent?.calendly_url ?? null

    return (
      <DashboardLayout>
        <div className="page-background print-no-color">
          <div className="container container-profile-freelance">
            <h2  className="text-center mb-5 mt-1">Mon Agent</h2>
            <div className="row">
              <div className="dashboard-row">
                <div className="dashboard-col">
                  <FreelanceAgent
                    agent={agent}
                    title="Mes coordonnées"
                    whatsApp={true}
                    appointmentCta={false}/>
                </div>
                <div className="dashboard-col">
                  <Card  className="dashboard-card-agent-description" title="Mon parcours">
                    <CardRow align="center">
                      <CardCol flex="1">
                        <p className="dashboard-card-col-txt">
                          {agent.description ? nl2br(agent.description) : null}
                        </p>
                      </CardCol>
                    </CardRow>
                  </Card>
                </div>
              </div>
              <div className="dashboard-row">
                <div className="dashboard-col">
                  <Card  className="dashboard-card-agent-description" title="Mon rôle chez Twineeds">
                    <CardRow align="center">
                      <CardCol flex="1">
                        <p className="dashboard-card-col-txt">
                          Mon objectif est de vous accompagner tout au long de votre parcours professionnel, en :
                        </p>
                        <br/>

                        <ul className="dashboard-card-col-txt">
                          <li>
                            vous proposant des opportunités adaptées à vos attentes et profil.
                          </li>
                          <li>
                            vous conseillant et aiguillant sur toutes les étapes et choix importants de votre carrière.
                          </li>
                        </ul>
                        <br/>
                        <p className="dashboard-card-col-txt">
                          Que ce soit pour vous aider à vous lancer en tant que consultant (type de structure,
                          positionnement tarifaire, etc.)
                          ou pour vous conseiller dans certains choix stratégiques (définition marque personnelle,
                          missions à accepter ou non, etc),
                          je suis à votre disposition pour en discuter !
                        </p>
                        <br/>
                        <p className="dashboard-card-col-txt">
                          Et ce que vous soyez en mission avec Twineeds, ou non !
                        </p>
                      </CardCol>
                    </CardRow>
                  </Card>
                </div>
                {calendlyUrl &&
                  <div className="dashboard-col">
                    <Card  className="dashboard-card-agent-description" title="Planifier un rendez-vous">
                      <CardRow align="center" direction="column">
                        <CardCol flex="1">
                          <ul className="dashboard-card-col-txt">
                            <li>Besoin de faire un point de carrière (positionnement tarifaire, types de missions souhaités, définition de votre marque personnelle, etc) ?</li>
                            <li>Vous souhaitez discuter d'un autre sujet en lien avec votre activité ?</li>
                          </ul>
                          <br/>
                          <p className="dashboard-card-col-txt">Réservez un créneau dans mon agenda pour que nous puissions échanger par téléphone :</p>
                        </CardCol>
                        <CardCol align="center">
                          <a className="btn btn-primary" href={calendlyUrl} target="_blank" rel="noopener noreferrer">
                            Réserver un rendez vous
                          </a>
                        </CardCol>
                      </CardRow>
                    </Card>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }
}
